


















import { computed, defineComponent } from "@vue/composition-api";
import { Notification } from "@scrile/api-provider/dist/api/NotificationsProvider";
import useAuthUser from "@/hooks/useAuthUser";
import { formatTimeInterval } from "@/lib/time";
import { TIME_MEASURAND } from "@/const";
import BaseIcon from "@/components/Base/BaseIcon";
import { AppointmentsTabNameEnum } from "@/views/PageAppointments/config";
import NotificationItemView from "../../NotificationItemView.vue";

export default defineComponent({
  name: "NotificationAppointmentReminder",
  components: { BaseIcon, NotificationItemView },
  props: {
    notification: { type: Object as () => Notification, required: true },
  },
  setup() {
    const { isCreator } = useAuthUser();
    const link = computed(() => ({
      name: "appointments",
      query: {
        tab: isCreator.value ? AppointmentsTabNameEnum.UPCOMING_WITH_ME : AppointmentsTabNameEnum.MY_UPCOMING,
      },
    }));
    return {
      formatTimeInterval,
      TIME_MEASURAND,
      link,
    };
  },
});
